<header class="app-header">
  @if (showSearch) {
    <div class="header-search">
      <input type="text" [placeholder]="'header.searchPlaceholder' | translate"
        (input)="onSearchInput($any($event.target).value)" />
        <i class="bi bi-search"></i>
      </div>
    }
    <!-- Mobile hamburger to toggle sidebar -->
    <button class="hamburger-btn" aria-label="Toggle sidebar" (click)="toggleSidebar()">
      <i class="bi bi-list"></i>
    </button>

    <div class="header-actions">
      @if (isAuthenticated && currentUser) {
        <div class="profile-menu-wrapper" #profileMenuWrapper>
          <button class="icon-btn" type="button" aria-label="Toggle Language" (click)="toggleLanguage()">
            <i class="bi bi-globe"></i>
          </button>
          <app-notification-bell></app-notification-bell>
          <button
            class="profile-avatar-btn"
            type="button"
            (click)="toggleProfileMenu()"
            [class.active]="showProfileMenu"
            >
            <div class="avatar-placeholder">{{ getInitials() }}</div>
            <div class="user-meta">
              <div class="user-name">{{ currentUser.displayName }}</div>
              <div class="user-role">{{ currentUser.email }}</div>
            </div>
            <span class="arrow-circle">
              <img src="assets/icons/arrow-down.svg" alt="open menu" width="24" height="24" />
            </span>
          </button>
          @if (showProfileMenu) {
            <div class="profile-dropdown" [ngClass]="currentLanguage=='ar'?'profile-dropdown-rtl':''">
              <div class="dropdown-header">
                <div class="dropdown-avatar">{{ getInitials() }}</div>
                <div class="user-info">
                  <div class="user-name">{{ currentUser.displayName }}</div>
                  <div class="user-email">{{ currentUser.email }}</div>
                </div>
              </div>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item" type="button">
                <i class="bi bi-person-circle"></i>
                <span>{{ 'header.profile' | translate }}</span>
              </button>
              <button class="dropdown-item" type="button">
                <i class="bi bi-gear"></i>
                <span>{{ 'header.settings' | translate }}</span>
              </button>
              <div class="dropdown-divider"></div>
              <button class="dropdown-item logout" type="button" (click)="logout()">
                <i class="bi bi-box-arrow-right"></i>
                <span>{{ 'header.logout' | translate }}</span>
              </button>
            </div>
          }
        </div>
      }
    </div>
  </header>
